export class Colors {
	public static yellow = '#f2ac40';
	public static darkGrey = '#364142';
	public static grey = '#435152';
	public static lightGrey = '#6f7a7a';
	public static dottedBorderColor: '#838380';
	public static borderGrey = '#9faaaa';
	public static lighterGrey = '#ccc';
	public static lightestGrey = '#ddd';
	public static white = '#fff';
	public static offWhite = '#F4F5F5';
	public static black = '#000';
	public static filterRed = '#d95b1e';
	public static debug = '#f00';
	public static red = 'rgb(255, 91, 91)';
	public static darkRed = '#BF0000';
	public static greenColor = '#008000';
	public static lightGreen = '#54BF0C';
	public static controllersGray = '#838E8E';
	public static controllersRed = '#EC4100';
	public static controllersBlue = '#008EEC';
	public static controllersBlueLight = '#EAF5FD';

	// iOS keyboard background (light mode) — used to tint the numeric InputAccessoryView bar.
	public static keyboardBackground = '#D1D5DB';

	public static pastelRed = '#ffb3ba';
	public static pastelOrange = '#ffdfba';
	public static pastelYellow = '#ffffba';
	public static pastelGreen = '#baffc9';
	public static pastelBlue = '#bae1ff';
	public static darkGreen = '#008000';
}

export const colorArray = [
    '#FF0000', // Red
    '#00FF00', // Green
    '#0000FF', // Blue
    '#FFFF00', // Yellow
    '#FF00FF', // Magenta
    '#00FFFF', // Cyan
    '#800000', // Maroon
    '#808000', // Olive
    '#008080', // Teal
    '#800080', // Purple
    '#FFA500', // Orange
    '#A52A2A', // Brown
    '#8A2BE2', // BlueViolet
    '#5F9EA0', // CadetBlue
    '#D2691E', // Chocolate
    '#FF7F50', // Coral
    '#6495ED', // CornflowerBlue
    '#DC143C', // Crimson
    '#00CED1', // DarkTurquoise
    '#ADFF2F', // GreenYellow
    '#FF69B4', // HotPink
    '#CD5C5C', // IndianRed
    '#4B0082', // Indigo
    '#F0E68C', // Khaki
    '#E6E6FA', // Lavender
    '#7CFC00', // LawnGreen
    '#FFFACD', // LemonChiffon
    '#ADD8E6', // LightBlue
    '#F08080', // LightCoral
    '#E0FFFF', // LightCyan
];
